// TikTok API Service - API حقيقي باستخدام PHP
class TikTokAPI {
  constructor() {
    this.apiUrl = '/tiktok-api.php'; // مسار ملف PHP
  }

  // التحقق من صحة اسم المستخدم
  validateUsername(username) {
    if (!username || typeof username !== 'string') {
      return { valid: false, error: 'اسم المستخدم مطلوب' };
    }

    // تنظيف اسم المستخدم
    const cleanUsername = username.trim().replace(/^@/, '');
    
    if (cleanUsername.length < 2) {
      return { valid: false, error: 'اسم المستخدم يجب أن يكون أكثر من حرفين' };
    }

    if (cleanUsername.length > 24) {
      return { valid: false, error: 'اسم المستخدم يجب أن يكون أقل من 25 حرف' };
    }

    // التحقق من الأحرف المسموحة
    const validChars = /^[a-zA-Z0-9._]+$/;
    if (!validChars.test(cleanUsername)) {
      return { valid: false, error: 'اسم المستخدم يحتوي على أحرف غير مسموحة' };
    }

    return { valid: true, username: cleanUsername };
  }

  // جلب إحصائيات TikTok الحقيقية
  async getLiveStats(username) {
    const validation = this.validateUsername(username);
    if (!validation.valid) {
      return { success: false, error: validation.error };
    }

    try {
      // استخدام ملف PHP لجلب البيانات الحقيقية
      const response = await fetch(`${this.apiUrl}?username=${encodeURIComponent(validation.username)}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        return {
          success: true,
          data: {
            ...result.data,
            lastUpdated: new Date().toISOString()
          }
        };
      } else {
        return {
          success: false,
          error: result.error || 'خطأ في جلب البيانات'
        };
      }

    } catch (error) {
      console.error('خطأ في جلب إحصائيات TikTok:', error);
      return {
        success: false,
        error: 'لا يمكن الاتصال بالخادم. تأكد من أن ملف tiktok-api.php موجود ويعمل بشكل صحيح.'
      };
    }
  }

  // جلب معلومات الهدايا بالتفصيل
  async getGiftsDetails(username) {
    const validation = this.validateUsername(username);
    if (!validation.valid) {
      return { success: false, error: validation.error };
    }

    try {
      const response = await fetch(`${this.apiUrl}?username=${encodeURIComponent(validation.username)}&type=gifts`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        return {
          success: true,
          data: {
            ...result.data,
            lastUpdated: new Date().toISOString()
          }
        };
      } else {
        return {
          success: false,
          error: result.error || 'خطأ في جلب الهدايا'
        };
      }

    } catch (error) {
      console.error('خطأ في جلب الهدايا:', error);
      return {
        success: false,
        error: 'لا يمكن الاتصال بالخادم. تأكد من أن ملف tiktok-api.php موجود ويعمل بشكل صحيح.'
      };
    }
  }

  // جلب التعليقات المباشرة
  async getLiveComments(username) {
    const validation = this.validateUsername(username);
    if (!validation.valid) {
      return { success: false, error: validation.error };
    }

    try {
      const response = await fetch(`${this.apiUrl}?username=${encodeURIComponent(validation.username)}&type=comments`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        return {
          success: true,
          data: {
            ...result.data,
            lastUpdated: new Date().toISOString()
          }
        };
      } else {
        return {
          success: false,
          error: result.error || 'خطأ في جلب التعليقات'
        };
      }

    } catch (error) {
      console.error('خطأ في جلب التعليقات:', error);
      return {
        success: false,
        error: 'لا يمكن الاتصال بالخادم. تأكد من أن ملف tiktok-api.php موجود ويعمل بشكل صحيح.'
      };
    }
  }

  // اختبار الاتصال بالخادم
  async testConnection() {
    try {
      const response = await fetch(`${this.apiUrl}?test=1`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      return response.ok;
    } catch (error) {
      console.error('خطأ في اختبار الاتصال:', error);
      return false;
    }
  }
}

export default TikTokAPI; 